import { Injectable } from "@angular/core";
import { EMPTY, Observable } from "rxjs";
import { RequestUtilsService } from "./requestUtils";
import { mapAnnotations } from "./requestMapperUtils";
import type { Annotation } from "../interfaces/annotation.interface";
import { GetHttpHeadersSimple } from "./serviceUtils";

@Injectable({
    providedIn: "root"
})
export class AnnotationService {
    constructor(private requestUtils: RequestUtilsService) {}

    getAnnotations(incidentId: string): Observable<Annotation[]> {
        if (!incidentId) return EMPTY;
        const url = `annotations?$filter=_objectid_value eq '${incidentId}'&$select=_objectid_value,annotationid,filename,documentbody,mimetype`;
        return this.requestUtils.createGetRequest<Annotation[]>(url, mapAnnotations);
    }

    deleteAnnotationFromCE(fileId: string): Observable<any> {
        if (!fileId) return EMPTY;
        const url = `annotations(${fileId})`;
        return this.requestUtils.createDeleteRequest<any>(url, (response) => response, GetHttpHeadersSimple);
    }
}
